<script lang="ts">
  import { fade } from "svelte/transition";
  import Advice from "./Advice.svelte";
  import Header from "./Header.svelte";
  import Questions from "./Questions.svelte";
  import { advice } from "../stores/advice";
  import { questionnaireValidation } from "../stores/validation";
  import {
    questionnaire,
    questionnaireComplete,
  } from "../stores/questionnaire";
  import { t } from "../stores/translations";
  import Button from "./shared/Button.svelte";
  import { onMount } from "svelte";
  import { googleTagManagerStore } from "../stores/googleTagManager";
  import { getNewMattressReason } from "../helpers/helpers";

  export let submitreset: boolean;

  onMount(() => {
    let gtm_started_event = window.dataLayer?.find(
      (element) => element["gtm.start"]
    );

    // In the time that this check is made the property of gtm_started_event doesn't exist yet
    // && gtm_started_event["gtm.uniqueEventId"]
    if (gtm_started_event) {
      googleTagManagerStore.setGtmActive(true);
      googleTagManagerStore.startQuestionnaire();
    }
  });

  /**
   * Scrolls to first invalid question
   */
  function scrollToFirstInvalidQuestion() {
    questionnaireValidation.activate();

    const questionSlug = $questionnaire.activeQuestions.find(
      (question) => question.selectedAnswer === null
    )?.slug;
    const element = $questionnaireValidation.htmlElements.find(
      (elements) => elements.slug === questionSlug
    )?.element;

    if (element) {
      scrollIntoView(element);
    }
  }

  function showAdvice() {
    let resultSlugs = {};

    const results = $questionnaire.activeQuestions.map((question) => {
      resultSlugs[question.slug] = question.selectedAnswer?.slug ?? null;

      return {
        questionId: question.id,
        answerId: question.selectedAnswer?.id ?? null,
      };
    });

    if ($googleTagManagerStore.gtmActive) {
      delete resultSlugs["length-weight"];
      delete resultSlugs["length-weight-partner"];

      const budgetSlug = Object.keys(resultSlugs).find((slug) =>
        slug.includes("budget")
      );

      delete resultSlugs[budgetSlug];

      resultSlugs["new-mattress-reason"] = getNewMattressReason(
        resultSlugs["new-mattress-reason"]
      );

      googleTagManagerStore.showAdvice(resultSlugs);
    }

    advice.loadAdvice(results);
  }

  /**
   * Scrolls the selected element into view.
   *
   * @param element The selected element.
   */
  function scrollIntoView(element: HTMLElement) {
    setTimeout(
      () =>
        element.scrollIntoView({
          behavior: "smooth",
        }),
      100
    );
  }
</script>

<div transition:fade class="app-container">
  <Header />

  <div class="questions-container">
    <Questions />
  </div>

  <div class="button-container">
    <Button
      on:click={$questionnaireComplete
        ? showAdvice
        : scrollToFirstInvalidQuestion}
    >
      {$t("questionnaire.show-advice")}
    </Button>
  </div>

  {#if $advice}
    <div use:scrollIntoView class="advice-container">
      <div >
        <Advice className="advice-instance" resetOnSubmit={submitreset} />
      </div>

      {#if $advice["advice-partner"] && $advice["mattress-type"] !== "two-person-mattress"}
          <Advice className = "advice-instance" adviceType="advice-partner" resetOnSubmit={submitreset} />
      {/if}
    </div>
  {/if}
</div>

<style lang="scss">
  @import "src/lib/styles/variables";
  @import "src/lib/styles/mixins";

  .app-container {
    background-color: $color-background;
    display: flex;
    flex-direction: column;

    & > .button-container {
      width: 20rem;
      margin-bottom: 1.5rem;
      align-self: center;
    }
  }

  .questions-container,
  .advice-container {
    background-color: $color-background;
  }

  .advice-container {
    padding: 2.5rem 0 1rem;

    & > .advice-instance:not(:first-of-type) {
      margin-top: 3rem;
    }
  }

  @include desktop {
    .app-container {
      align-items: center;
    }

    .questions-container {
      width: 43rem;
    }
  }
</style>
